"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkActionItem = void 0;
const react_1 = __importStar(require("react"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const table_context_1 = require("../table-context");
exports.BulkActionItem = react_1.forwardRef(function BulkActionItem({ action, closeMenu }, ref) {
    const componentRef = react_1.useRef(null);
    const { selected } = react_1.useContext(table_context_1.TableSelectedContext);
    const disabled = action.disableFilteredBulkAction && selected.length === 0;
    return (react_1.default.createElement(MenuItem_1.default, { component: "div", ref: ref, onClick: () => {
            action.action(componentRef.current);
            closeMenu();
        }, disabled: disabled },
        react_1.default.createElement(react_1.default.Fragment, null,
            action.label,
            action.Component && react_1.default.createElement(action.Component, { ref: componentRef }))));
});
//# sourceMappingURL=bulk-action-item.js.map